import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import React, { useState } from "react";
import { Card, Col, Container, Nav, Navbar, Row } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { postPriceListConfig } from "../services/getPriceCode";
import { errorMessage, successMessage } from "../utils/alertMessage";
import { getUserData } from "../utils/localStorage";
import "jspdf-autotable";
import jsPDF from "jspdf";
import AdminMenu from "../pages/AdminMenu";

const MyPackageList = () => {
  const navigate = useNavigate();

  const { state } = useLocation();

  const userData = getUserData();
  let brandId = userData.brandProfileData.id;

  const priceListDTO = state.priceListDTO;
  const userRole = userData.userProfileRole;

  // State for search query and filtered garments
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredGarments, setFilteredGarments] = useState(null);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [submitButtonPressed, setSubmitButtonPressed] = useState(false);
  const [visible, setVisible] = useState(false);

  // Function to handle search input change
  const handleSearchInputChange = (event) => {
    setSearchQuery(event.target.value);
    filterGarments(event.target.value);
  };

  const allServices = Object.keys(priceListDTO).reduce((services, garment) => {
    Object.keys(priceListDTO[garment]).forEach((category) => {
      Object.keys(priceListDTO[garment][category]).forEach((service) => {
        if (!services.includes(service)) {
          services.push(service);
        }
      });
    });
    return services;
  }, []);

  const uniqueServices = Array.from(new Set(allServices));

  const [formData, setFormData] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const handleInputChange = (event, garmentName, categoryName, serviceName) => {
    const value = event.target.checked; // Get the checked value from the checkbox
    setFormData((prevFormData) => ({
      ...prevFormData,
      [`${garmentName}-${categoryName}-${serviceName}`]: value,
    }));
  };

  // Function to filter garments based on search query
  const filterGarments = (query) => {
    const filtered = Object.keys(priceListDTO).filter((garment) =>
      garment.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredGarments(filtered);
  };

  // Function to handle "Select All" checkbox change event
  const handleSelectAllChange = (event) => {
    const isChecked = event.target.checked;
    setSelectAllChecked(isChecked);
    const updatedFormData = {};
    Object.keys(priceListDTO).forEach((garment) => {
      Object.keys(priceListDTO[garment]).forEach((category) => {
        Object.keys(priceListDTO[garment][category]).forEach((service) => {
          updatedFormData[`${garment}-${category}-${service}`] = isChecked;
        });
      });
    });
    setFormData(updatedFormData);
  };


    const garments =
      filteredGarments?.sort() || Object.keys(priceListDTO)?.sort();
  
  

  // Function to render garments
  const renderGarments = () => {
    let serialNo = 1;
    return garments.map((garment) =>
      {
        let garmentPrinted = false;
      
        return Object.keys(priceListDTO[garment]).map((category, index) => {
        // Check if at least one service in the category has a valid price
        const hasValidPrice = uniqueServices.some((service) => {
          const priceData =
            priceListDTO[garment] &&
            priceListDTO[garment][category] &&
            priceListDTO[garment][category][service];


          return priceData && priceListDTO[garment][category][service].status;
        });


        if (!hasValidPrice) return null;


        const garmentCell = !garmentPrinted ? (
          <td>
            {garment}
          </td>
        ) : (
         <td></td>
        );


          const indexCell = !garmentPrinted ? (
            <td>
              {serialNo++}
            </td>
          ) : (
            <td></td>
          );

        garmentPrinted = true;
        return (
          <tr key={`${garment}-${category}`}>
            {indexCell}
            {garmentCell}
            <td>{category}</td>
            {Object.keys(priceListDTO[garment][category]).map((service) => (
              <td key={`${garment}-${category}-${service}`}>
                <input
                  type="checkbox"
                  style={{ width: 25, height: 25 }}
                  id={`${garment}-${category}-${service}`}
                  name={`${garment}-${category}-${service}`}
                  checked={
                    formData[`${garment}-${category}-${service}`] !== undefined
                      ? formData[`${garment}-${category}-${service}`]
                      : priceListDTO[garment][category][service].status
                  }
                  onChange={(e) =>
                    handleInputChange(e, garment, category, service)
                  }
                />
              </td>
            ))}
          </tr>
        );
      })
  });
  };

  const downloadPDF = (data, uniqueServices, type) => {
    const doc = new jsPDF("landscape");
    const logoImg = new Image();
    // logoImg.src = logoBig;

    // Adjust this as necessary
    logoImg.src = "/Img/DhobiCart.png";

    // doc.addImage(logoImg, "PNG", 10, 5, 50, 15);
    doc.setFontSize(20);
    doc.text("Package Garment Management", 110, 25);

   

    const tableData = data
      .map((garment) => {
        return Object.keys(priceListDTO[garment])
          .map((category, index) => {
            const row = [garment, category];
            let includeRow = false;
            uniqueServices.forEach((service) => {
              const priceData = priceListDTO[garment][category][service];
              if (priceData && priceData?.status === true) {
                includeRow = true;
                row.push(
                  formData[`${garment}-${category}-${service}`] !== undefined
                    ? formData[`${garment}-${category}-${service}`]
                    : "True"
                );
              } else {
                row.push("");
              }
            });
            return includeRow ? row : null;
          })
          .filter((row) => row !== null);
      })
      .flat();

    

    const tableHeaders = ["Garment Name", "Category", ...uniqueServices];

    doc.autoTable({
      head: [tableHeaders],
      body: tableData,
      startY: 30,
      theme: "grid",
      styles: {
        fontSize: 10,
      },
    });
    if (type === "print") {
      // Create blob URL
      const blob = doc.output("blob");
      const blobURL = URL.createObjectURL(blob);

      // Open blob URL in a new window
      const printWindow = window.open(blobURL);
      if (printWindow) {
        printWindow.onload = () => {
          printWindow.print();
        };
      }
    } else {
      // doc.save("Package-garment-management.pdf");
      doc.save("Package-" + state.selectedPriceCode + ".pdf");
    }
  };

  const handleSubmit = () => {
    setSubmitButtonPressed(true);
    const submittedData = [];

    Object.keys(priceListDTO).forEach((garment) => {
      Object.keys(priceListDTO[garment]).forEach((category) => {
        Object.keys(priceListDTO[garment][category]).forEach((service) => {
          const serviceData = priceListDTO[garment][category][service];
          const inputValue = formData[`${garment}-${category}-${service}`];
          // const originalAmount = serviceData.amount;
          const originalStatus = serviceData.status;
          const status = inputValue !== undefined ? inputValue : originalStatus;

          if (inputValue !== undefined && inputValue !== originalStatus) {
            submittedData.push({
              id: serviceData.id,
              garmentName: serviceData.garmentName,
              category: serviceData.category,
              brandAppServiceName: service,
              garmentCategory: serviceData.garmentCategory,
              brandAppService: serviceData.brandAppService,
              serviceUnit: serviceData.serviceUnit,
              amount: serviceData.amount,
              minAmount: serviceData.minAmount,
              status: status,
            });
          }
        });
      });
    });

    let Data = {
      priceListDTO: submittedData,
      serviceUnit: state.serviceUnit,
      appServiceList: state.appServiceList,
      priceId: state.priceId,
    };

    postPriceListConfig(brandId, Data)
      .then((response) => {
        if (!response.data.error) {
          if (response.data.success === false) {
            errorMessage(response.data.message);
            setSubmitButtonPressed(false);
          } else {
            successMessage(response.data.message);
            setSubmitButtonPressed(false);
            if(userRole === "BY_ADMIN" || userRole === "BY_SUB_ADMIN_USER") {

              navigate("/TariffManagement")
              } else {
                navigate("/StorePriceCode")
              }
              
          }
        } 
      })
      .catch((err) => {
        errorMessage();
      });
    setSubmitted(true);
  };

  const handleAddMoreGarment = () => {
    navigate("/package-list", {
      state: {
        priceListDTO: priceListDTO,
        selectedPriceCode: state.selectedPriceCode,
        type: "package",
        serviceUnit: state.serviceUnit,
        appServiceList: state.appServiceList,
        priceId: state.priceId,
      },
    });
  };


  return (
    <div className="flex-1">
    <div
      className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
      style={{
        "--surface-0": "#1752AA",
      }}
    >
      <div className="flex-1 flex ml-3 mr-3">
        <div className="flex-1 flex ">
          <div className="ml-3 flex justify-content-center align-items-center">
            <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
              <i
                className="pi pi-angle-left"
                onClick={() => 
                  {
                  if(userRole === "BY_ADMIN" || userRole === "BY_SUB_ADMIN_USER") {
                    navigate("/package-list-selection")
                  } else {
                    navigate("/StorePriceCode")
                  }
                }
                
                }
                style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
              ></i>
            </div>
          </div>
          <div className="flex-1 ml-5">
            <p className="text-2xl text-white font-bold uppercase">Package Garment Management</p>
          </div>
        </div>

         

        <div
          className="flex justify-content-center align-items-center cursor-pointer"
          onClick={() => setVisible(true)}
        >
          <i
            className="pi pi-bars"
            style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
          ></i>
        </div>
      </div>
    </div>
      <Container fluid style={{ marginBottom: 60 }}>
        <div style={{ textAlign: "center", marginBottom: 30 }}>
          <h3>My Package Garment Management</h3>
        </div>

        <div className="row mb-3">
          <div className="col-md-2">
            <div
              style={{
                // backgroundColor: "#1752AA",
                // color: "white",
                marginTop: 20,
              }}
            >
              <div
                style={{
                  textDecoration: "none",
                  display: "flex",
                  // flex: 1,
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  // width: "280px",
                  // height: "170px",
                  backgroundColor: "#fff",
                  paddingTop: 25,
                  borderRadius: 20,
                  cursor: "pointer",
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                  transition: "0.3s",
                  margin: 5,
                  marginTop: 15,
                  marginBottom: 15,
                }}
              >
                <div className="row mb-3">
                  <div className="col-md-12">
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <img
                        style={{ width: "46px" }}
                        src="/Img/box.png"
                        alt="logo"
                      />
                    </div>
                    <div style={{ textAlign: "center", height: 70 }}>
                      <h5>
                        {state.type === "price" ? "Price" : "Package"} List
                      </h5>
                      <p className="service-list display-contents">
                        {state.selectedPriceCode}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-8">
            <div
              style={{
                // backgroundColor: "#1752AA",
                // color: "white",
                marginTop: 20,
              }}
            >
              <div
                style={{
                  textDecoration: "none",
                  display: "flex",
                  // flex: 1,
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  // width: "280px",
                  // height: "280px",
                  backgroundColor: "#fff",
                  paddingTop: 25,
                  borderRadius: 20,
                  cursor: "pointer",
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                  transition: "0.3s",
                  margin: 5,
                  marginTop: 15,
                  marginBottom: 15,
                }}
              >
                <div className="row mb-3">
                  <div className="col-md-12">
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <img
                        style={{ width: "46px" }}
                        src="/Img/services.png"
                        alt="logo"
                      />
                    </div>
                    <div style={{ textAlign: "center", height: 70 }}>
                      <h5>App Services</h5>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <p className="service-list display-contents">
                          {state.appServiceList.join(", ")}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-2">
            <div
              style={{
                // backgroundColor: "#1752AA",
                // color: "white",
                marginTop: 20,
              }}
            >
              <div
                style={{
                  textDecoration: "none",
                  display: "flex",
                  // flex: 1,
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  // width: "280px",
                  // height: "280px",
                  backgroundColor: "#fff",
                  paddingTop: 25,
                  borderRadius: 20,
                  cursor: "pointer",
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                  transition: "0.3s",
                  margin: 5,
                  marginTop: 15,
                  marginBottom: 15,
                }}
              >
                <div className="row mb-3">
                  <div className="col-md-12">
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <img
                        style={{ width: "46px", color: "#fff" }}
                        src="/Img/quantity.png"
                        alt="logo"
                      />
                    </div>
                    <div style={{ textAlign: "center", height: 70 }}>
                      <h5>Service Unit</h5>
                      <p className="service-list display-contents">
                        {" "}
                        {state.serviceUnit === "Qty"
                          ? "PIECE"
                          : state.serviceUnit}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Row>
          <Col style={{ margin: 10 }}>
            <main id="main" className="main mb-3">
              <section className="section">
                <div
                  style={{
                    margin: 20,
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <InputText
                    value={searchQuery}
                    onChange={handleSearchInputChange}
                    placeholder="Search Garment"
                  />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                  <div className="flex justify-content-center align-items-center mr-4">
                      <Button
                        label="Add More Garment"
                        onClick={handleAddMoreGarment}
                        style={{ position: "relative" }}
                        className="font-bold px-5 py-3 p-button-raised p-button-rounded white-space-nowrap"
                      />
                    </div>
                    <div style={{ alignSelf: "center" }}>
                      <h5>Select All</h5>
                    </div>
                    <div style={{ marginLeft: 20, marginRight: 20 }}>
                      <input
                        type="checkbox"
                        style={{ width: 30, height: 30 }}
                        checked={selectAllChecked}
                        onChange={handleSelectAllChange}
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: 20,
                        // marginTop: 10,
                      }}
                    >
                      <i
                        onClick={() =>
                          downloadPDF(
                            filteredGarments?.sort() ||
                              Object.keys(priceListDTO)?.sort(),
                            uniqueServices,
                            "download"
                          )
                        }
                        className="pi pi-download"
                        style={{
                          fontSize: "2rem",
                          color: "#1e439b",
                          cursor: "pointer",
                        }}
                      ></i>
                      <i
                        onClick={() =>
                          downloadPDF(
                            filteredGarments?.sort() ||
                              Object.keys(priceListDTO)?.sort(),
                            uniqueServices,
                            "print"
                          )
                        }
                        className="pi pi-print"
                        style={{
                          fontSize: "2rem",
                          color: "#ff0101",
                          cursor: "pointer",
                        }}
                      ></i>
                    </div>
                  </div>
                </div>
                <div className="tableFixHead">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>S No.</th>
                        <th>Garment Name</th>
                        <th>Category</th>
                        {uniqueServices.map((service) => (
                          <th key={service}>{service}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>{renderGarments()}</tbody>
                  </table>
                </div>
                 <div className="flex justify-content-center align-items-center mt-4">
                                  <Button
                                    label="Submit"
                                    onClick={handleSubmit}
                                    disabled={submitButtonPressed}
                                    style={{ position: "relative" }}
                                    className="font-bold px-5 py-3 p-button-raised p-button-rounded white-space-nowrap"
                                  />
                                </div>
              </section>
            </main>
          </Col>
        </Row>
        {/* <div style={{ color: "red" }}>
          <h2>
            Note : Blank Fields are considered as 0 (zero) price. Services with
            0 (zero) price will not be displayed in price list{" "}
          </h2>
        </div> */}
      </Container>
      {/*<div
        style={{
          position: "fixed",
          bottom: 20,
          width: "100%",
          textAlign: "center",
        }}
      >
        <Button
          label="Submit"
          onClick={handleSubmit}
          disabled={submitButtonPressed}
          className="font-bold px-5 py-3 p-button-raised p-button-rounded white-space-nowrap"
          style={{ position: "relative" }}
        />
      </div>*/}
      <footer style={{ backgroundColor: "#FBFBFB" }}>
        <Container fluid>
          <Row>
            <Col>
              <Nav className="flex social-media-div" style={{ marginLeft: 30 }}>
                <Link
                  to="https://www.youtube.com/channel/UCKdUWjGim18SoHC2jLbFsiw"
                  target="_blank"
                >
                  <i
                    className="pi pi-youtube"
                    style={{
                      fontSize: "2rem",
                      color: "red",
                      cursor: "pointer",
                    }}
                  ></i>
                </Link>
                <Link
                  to="https://www.instagram.com/dhobicart/?hl=en"
                  target="_blank"
                >
                  <i
                    className="pi pi-instagram"
                    style={{
                      fontSize: "2rem",
                      color: "#d62976",
                      cursor: "pointer",
                    }}
                  ></i>
                </Link>
                <Link
                  to="https://www.linkedin.com/company/71974228/admin/dashboard/"
                  target="_blank"
                >
                  <i
                    className="pi pi-linkedin"
                    style={{
                      fontSize: "2rem",
                      color: "#0072b1",
                      cursor: "pointer",
                    }}
                  ></i>
                </Link>
                <Link
                  to="https://www.facebook.com/oneindiatechno"
                  target="_blank"
                >
                  <i
                    className="pi pi-facebook"
                    style={{
                      fontSize: "2rem",
                      color: "#1877F2",
                      cursor: "pointer",
                    }}
                  ></i>
                </Link>
                <Link
                  to="https://play.google.com/store/apps/details?id=com.dhobicartV2"
                  target="_blank"
                >
                  <i
                    className="pi pi-android"
                    style={{
                      fontSize: "2rem",
                      color: "#a4c639",
                      cursor: "pointer",
                    }}
                  ></i>
                </Link>
                <Link to="tel:+91 9319518337" target="_blank">
                  <i
                    className="pi pi-phone"
                    style={{
                      fontSize: "2rem",
                      color: "#1877F2",
                      cursor: "pointer",
                    }}
                  ></i>
                </Link>
              </Nav>
            </Col>
            {/*<Col>
              <Link
                to="https://www.oneindiatech.com/?page_id=75"
                target="_blank"
                style={{ textDecoration: "none", fontSize: 20 }}
              >
                Contact Us!
              </Link>
              <p>Phone : +91 9319518337</p>
            </Col>*/}
          </Row>
          <Row>
            <Col>
              <div className="text-center p-3" style={{ fontSize: 16 }}>
                &copy; {new Date().getFullYear()} Copyright:{" "}
                <a className="text-dark" href="https://oneindiatech.com/">
                  One India Technologies Pvt. Ltd.
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default MyPackageList;
